// extracted by mini-css-extract-plugin
export default {"container":"YmTfML","message":"w3sW5F","details":"siFTVT","meta":"Awbmbe"};